import { Route, Routes } from 'react-router-dom';
import { publicRoutes, cabinetRoutes } from './routes';
import ProtectedRoute from './ProtectedRoute';
import CabinetLayout from '../components/CabinetLayout';
import useScrollToTop from '../hooks/useScrollToTop';

export default function AppRoutes() {
  useScrollToTop();
  return (
    <Routes>
      {publicRoutes.map((r) => (
        <Route key={r.path} path={r.path} element={r.element} />
      ))}
      <Route
        path="/cabinet"
        element={(
          <ProtectedRoute>
            <CabinetLayout />
          </ProtectedRoute>
        )}
      >
        {cabinetRoutes.map((r) => (
          r.index ? (
            <Route key="index" index element={r.element} />
          ) : (
            <Route key={r.path} path={r.path} element={r.element} />
          )
        ))}
      </Route>
    </Routes>
  );
}
